import { useEffect, useState } from "react";
import { toast } from "sonner";
import { ShieldCheck } from "lucide-react";
import { Checkbox } from "@/components/ui/checkbox";
import { useAuth } from "@/context/AuthContext";
import { api, errMsg } from "@/lib/api";

export const PermissionMatrix = () => {
  const { user } = useAuth();
  const editable = user.role === "superadmin";
  const [data, setData] = useState(null);
  const [perms, setPerms] = useState(null);
  useEffect(() => {
    api.get("/admin/permissions").then((r) => { setData(r.data); setPerms(r.data.permissions); }).catch(() => {});
  }, []);
  if (!data) return null;

  const toggle = (action, pos) => {
    const cur = perms[action];
    setPerms({ ...perms, [action]: cur.includes(pos) ? cur.filter((p) => p !== pos) : [...cur, pos] });
  };
  const save = async () => {
    try {
      const r = await api.put("/admin/permissions", perms);
      setPerms(r.data.permissions);
      toast.success("Hak jabatan disimpan");
    } catch (e) {
      toast.error(errMsg(e));
    }
  };

  return (
    <div className="bg-white rounded-2xl border border-slate-200 p-5 mt-6 max-w-3xl" data-testid="permission-matrix">
      <h2 className="font-bold text-slate-900 flex items-center gap-2"><ShieldCheck className="h-5 w-5 text-violet-600" /> Hak Sesuai Jabatan</h2>
      <p className="text-xs text-slate-500 mt-1">Centang jabatan yang boleh melakukan aksi. Super Admin selalu bisa semua aksi.{!editable && " Hanya Super Admin yang dapat mengubah."}</p>
      <div className="overflow-x-auto mt-4">
        <table className="w-full text-sm">
          <thead><tr className="text-left text-xs text-slate-600"><th className="p-2">Aksi</th>{data.positions.map((p) => <th key={p} className="p-2 text-center whitespace-nowrap">{p}</th>)}</tr></thead>
          <tbody>
            {Object.entries(data.actions).map(([key, label]) => (
              <tr key={key} className="border-t border-slate-100">
                <td className="p-2 font-medium">{label}</td>
                {data.positions.map((p) => (
                  <td key={p} className="p-2 text-center">
                    <Checkbox checked={perms[key].includes(p)} disabled={!editable} onCheckedChange={() => toggle(key, p)} data-testid={`perm-${key}-${p.replace(/\s/g, "-")}`} />
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {editable && <button onClick={save} data-testid="permission-save" className="mt-4 bg-violet-600 hover:bg-violet-700 text-white font-semibold px-5 py-2.5 rounded-xl">Simpan Hak Jabatan</button>}
    </div>
  );
};
